import { z } from "zod";

const statusReactionSchema = z
  .object({
    upvotes_count: z.number().default(0),
    upvotes_history: z.array(z.number()).default(new Array(7).fill(0)),
    downvotes_count: z.number().default(0),
    downvotes_history: z.array(z.number()).default(new Array(7).fill(0)),
  })
  .transform((reaction) => ({
    ...reaction,
    total_count: reaction.upvotes_count + reaction.downvotes_count,
  }));

type StatusReaction = z.infer<typeof statusReactionSchema>;

export { statusReactionSchema, type StatusReaction };
